import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01d07c74"
import script from "./copyItem.js?vue&type=script&lang=js&external"
export * from "./copyItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports